import React, { useState, useEffect, useContext } from "react";
import { API_URL } from "../../components/api";
import { formatDateTime } from "../../../utils/dateFormat";
import {
  DataGrid,
  GridToolbarContainer,
  GridToolbarColumnsButton,
  GridToolbarFilterButton,
  GridToolbarExport,
  GridFooterContainer,
  GridFooter,
  GridPagination,
} from "@mui/x-data-grid";
import Typography from "@mui/material/Typography";
import ExcelSVG from "./ExcelSVG.svg";
import FilterSVG from "./FilterSVG.svg";
import * as XLSX from "xlsx";
import Checkbox from "@mui/material/Checkbox";
import CustomizedActions from "./BulkActions";
import Modal from "react-bootstrap/Modal";
import Button from "react-bootstrap/Button";
import AuthContext from "../../context/AuthContext";
import axios from "axios";

import Notes from "./notes";
import ReceiptTable from "./ReceiptsTable";
import Notification from "./SendNotification";
import Cards from "./labels";
import Statement from "./statement";
import "./report.css";
import { sortByPaymentDate } from "./paymentDateSort";

function ICON() {
  const { user } = useContext(AuthContext);

  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(true);
  const [searchQuery, setSearchQuery] = useState("");
  const [Client, setClient] = useState("");
  const [Fullname, setFullname] = useState("");

  const [Cl, setCl] = useState("");
  const [checkedRows, setCheckedRows] = useState([]);
  const [show, setShow] = useState(false);
  const [showNotification, setShowNotification] = useState(false);
  const [showReceipt, setShowReceipt] = useState(false);

  // New state for postpone modal
  const [showCollectedModal, setShowCollectedModal] = useState(false);
  const [showPostponeModal, setShowPostponeModal] = useState(false);
  const [selectedSubscriptionId, setSelectedSubscriptionId] = useState(null);

  const CloseCollect = () => setShow(false);
  const ShowCollect = () => setShow(true);

  const CloseNotification = () => setShowNotification(false);
  const ShowNotification = () => setShowNotification(true);

  const CloseReceipt = () => setShowReceipt(false);
  const ShowReceipt = () => setShowReceipt(true);

  const ClosePostponeModal = () => setShowPostponeModal(false);
  const ShowPostponeModal = (sub_id) => {
    setSelectedSubscriptionId(sub_id);
    setShowPostponeModal(true);
  };

  const CloseCollectedModal = () => setShowCollectedModal(false);
  const ShowCollectedModal = (sub_id) => {
    setSelectedSubscriptionId(sub_id);
    setShowCollectedModal(true);
  };

  const [showStatement, setShowStatement] = useState(false);

  const CloseStatement = () => setShowStatement(false);
  const ShowStatement = () => setShowStatement(true);

  const [filters, setFilters] = useState({
    status: "",
    fullname_en: "",
    suffix: "",
    balance_usd: "",
    balance: "",
    client_notes: "",
    payment_date: "",
    due: "",
    expiration_date: "",
    collector: "",
    label: "",
    labels: "",
    note_details: "",
  });
  const [showFilterModal, setShowFilterModal] = useState(false);
  const [gridFilterModel, setGridFilterModel] = useState({
    items: [],
  });

  const [searchInput, setSearchInput] = useState(""); // To capture search input

  // NEW: State to track column visibility
  const [columnVisibilityModel, setColumnVisibilityModel] = useState({});
  const [searchFilterTimeout, setSearchFilterTimeout] = useState(null);

  const handlePostponeConfirm = async () => {
    try {
      const authTokens = JSON.parse(localStorage.getItem("authTokens"));
      const response = await axios.post(
        `${API_URL}/accounting/info/Postpone/`,
        {
          action: "postpone",
          sub_id: selectedSubscriptionId,
          username: user.username,
        },
        {
          headers: {
            Authorization: `Bearer ${authTokens.access}`,
          },
        }
      );

      if (response.status === 200) {
        fetchData(); // Refresh data after successful postpone
        setShowPostponeModal(false);
        console.log(response);
      }
    } catch (error) {
      console.error(error);
    }
  };

  const handleCollectedConfirm = async () => {
    try {
      const authTokens = JSON.parse(localStorage.getItem("authTokens"));
      const response = await axios.post(
        `${API_URL}/accounting/info/Collected/`,
        {
          action: "toBeCollected",
          sub_id: selectedSubscriptionId,
          username: user.username,
        },
        {
          headers: {
            Authorization: `Bearer ${authTokens.access}`,
          },
        }
      );
      if (response.status === 200) {
        fetchData(); // Refresh data after successful postpone
        setShowCollectedModal(false);
        console.log(response);
      }
    } catch (error) {
      console.error(error);
    }
  };

  const fetchData = async () => {
    try {
      const authTokens = JSON.parse(localStorage.getItem("authTokens"));
      const response = await axios.get(`${API_URL}/accounting/info/ICON/`, {
        headers: {
          Authorization: `Bearer ${authTokens.access}`,
        },
        params: {
          username: user.username,
        },
      });

      if (response.status === 200) {
        setData(sortByPaymentDate(response.data));
      }
    } catch (error) {
      console.error(error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchData();
  }, [user.username]);

  const getStatusCellStyle = (params) => {
    let statusColor = "";
    switch (params.value) {
      case "offline":
        statusColor = "status-offline";
        break;
      case "online":
        statusColor = "status-online";
        break;
      case "inactive":
        statusColor = "status-inactive";
        break;
      case "expired":
        statusColor = "status-expired";
        break;
      case "hold":
        statusColor = "status-hold";
        break;
      case "HSI":
        statusColor = "status-hsi";
        break;
      default:
        break;
    }
    return statusColor;
  };

  const [pageSize, setPageSize] = useState(100);
  const [currentPage, setCurrentPage] = useState(0);
  const paginatedRows = () => {
    const start = currentPage * pageSize;
    const end = start + pageSize;
    return filteredRows.slice(start, end);
  };

  const areAllRowsSelected = () => {
    const currentViewRows = paginatedRows();
    const currentViewIds = currentViewRows.map((row) => row.subscription_id);
    return currentViewIds.every((id) => checkedRows.includes(id));
  };

  const handleSelectAllCheckboxes = () => {
    const currentViewRows = paginatedRows(); // Get rows currently visible
    const currentViewIds = currentViewRows.map((row) => row.subscription_id);

    if (areAllRowsSelected()) {
      // Deselect if all currently visible rows are selected
      setCheckedRows(checkedRows.filter((id) => !currentViewIds.includes(id)));
    } else {
      // Select all visible rows if not all are selected
      setCheckedRows([
        ...checkedRows,
        ...currentViewIds.filter((id) => !checkedRows.includes(id)),
      ]);
    }
  };
  const columns = [
    {
      field: "checkbox",
      headerName: "",
      width: 100,
      renderHeader: () => (
        <Checkbox
          indeterminate={
            checkedRows.length > 0 && checkedRows.length < data.length
          }
          checked={checkedRows.length === data.length}
          onChange={(event) => handleSelectAllCheckboxes(event)}
        />
      ),
      renderCell: (params) => (
        <Checkbox
          className="subcheck"
          checked={checkedRows.includes(params.row.subscription_id)}
          onChange={(event) =>
            handleCheckboxChange(event, params.row.subscription_id)
          }
        />
      ),
    },
    {
      field: "status",
      headerName: "Status",
      flex: 2,
      minWidth: 100,
      cellClassName: (params) => getStatusCellStyle(params),
    },
    {
      field: "fullname_en",
      headerName: "Full Name",
      flex: 2,
      minWidth: 250,
    },
    {
      field: "suffix",
      headerName: "Suffix",
      flex: 2,
      minWidth: 100,
    },
    {
      field: "balance_usd",
      headerName: "Balance (USD)",
      flex: 1,
      minWidth: 150,
    },
    {
      field: "balance",
      headerName: "Initial Balance",
      flex: 1,
      minWidth: 150,
    },
    {
      field: "client_notes",
      headerName: "Client Notes",
      flex: 1,
      minWidth: 150,
    },
    {
      field: "payment_date",
      headerName: "Payment Date",
      flex: 1,
      minWidth: 200,
      sortable: true,
      sort: "asc",
      valueFormatter: (params) => {
        const date = new Date(params.value);
        if (isNaN(date.getTime())) {
          return date.toLocaleString("en-GB", {
            day: "2-digit",
            month: "2-digit",
            year: "numeric",
          }); // Print this if the date is invalid
        }
        return date.toLocaleString("en-GB", {
          day: "2-digit",
          month: "2-digit",
          year: "numeric",
        });
      },
    },
    {
      field: "due",
      headerName: "Due",
      flex: 1,
      minWidth: 150,
    },
    {
      field: "expiration_date",
      headerName: "Expiration Date",
      flex: 1,
      minWidth: 200,
      valueFormatter: (params) => {
        const date = new Date(params.value);
        if (isNaN(date.getTime())) {
          return date.toLocaleString("en-GB", {
            day: "2-digit",
            month: "2-digit",
            year: "numeric",
          }); // Print this if the date is invalid
        }
        return date.toLocaleString("en-GB", {
          day: "2-digit",
          month: "2-digit",
          year: "numeric",
        });
      },
    },
    {
      field: "collector",
      headerName: "Collector",
      flex: 2,
      minWidth: 150,
    },
    {
      field: "label",
      headerName: "MC Category",
      flex: 2,
      minWidth: 100,
    },
    {
      field: "labels",
      headerName: "Labels",
      flex: 1,
      minWidth: 120,
      renderCell: (params) => {
        return <Cards sub_id={params.row.subscription_id} />;
      },
    },
    {
      field: "note_details",
      headerName: "Latest Note",
      flex: 2,
      minWidth: 250,
      valueGetter: (params) => {
        const { note_user, latest_note } = params.row;
        return note_user && latest_note
          ? `${note_user}: ${latest_note}`
          : "No Note";
      },
    },
    {
      field: "actions",
      headerName: "Actions",
      minWidth: 700,
      flex: 2,
      renderCell: (params) => (
        <div>
          <button
            className="edit-client"
            onClick={() => {
              setClient(params.row.subscription_id);
              setFullname(params.row.fullname_en);
              ShowCollect();
            }}
          >
            Notes
          </button>
          <button
            className="edit-client"
            onClick={() => {
              setCl(params.row.client_id);
              ShowReceipt();
            }}
          >
            Receipt
          </button>
          <button
            className="edit-client"
            onClick={() => {
              setClient(params.row.subscription_id);
              setFullname(params.row.fullname_en);
              ShowNotification();
            }}
          >
            Notifications
          </button>
          <button
            className="edit-client postpone-btn"
            onClick={() => ShowPostponeModal(params.row.subscription_id)}
          >
            Postpone
          </button>
          <button
            className="edit-client postpone-btn"
            onClick={() => ShowCollectedModal(params.row.subscription_id)}
          >
            To Be Collected
          </button>
          <button
            onClick={() => {
              ShowStatement();
              setCl(params.row.client_id);
            }}
            className="edit-client"
          >
            Statement
          </button>
        </div>
      ),
    },
  ];
  const formatDate = (dateString) => formatDateTime(dateString);
  const getRowId = (row) => row.subscription_id;

  const handleCheckboxChange = (event, subscriptionId) => {
    const checked = event.target.checked;
    setCheckedRows((prevCheckedRows) => {
      if (checked) {
        return [...prevCheckedRows, subscriptionId];
      } else {
        return prevCheckedRows.filter((id) => id !== subscriptionId);
      }
    });
  };

  const delaySearchFilter = (input) => {
    setSearchQuery(input);
  };

  useEffect(() => {
    // Save "searchValue" value before clearing other session storage items
    const searchValue = sessionStorage.getItem("searchSpecial");

    // Clear all session storage items except "searchValue"
    Object.keys(sessionStorage).forEach((key) => {
      if (key !== "searchSpecial") {
        sessionStorage.removeItem(key);
      }
    });

    // Restore "searchValue" value if needed
    if (searchValue) {
      sessionStorage.setItem("searchSpecial", searchValue);
      setSearchQuery(searchValue);
    }
  }, []);

  const handleSearchChange = (event) => {
    const query = event.target.value;
    setSearchInput(query);
    sessionStorage.setItem("searchSpecial", query);
    setCurrentPage(0);

    if (searchFilterTimeout) {
      clearTimeout(searchFilterTimeout);
    }

    const newTimeout = setTimeout(() => {
      delaySearchFilter(query);
    }, 100);
    setSearchFilterTimeout(newTimeout);
  };

  const filteredRows = data.filter((row) => {
    // ✅ SHOW ONLY rows where Initial Balance > 0
    if (Number(row.balance) <= 0) {
      return false;
    }

    // Apply search query filter
    const searchMatch = searchQuery
      .split(" ")
      .every((word) =>
        Object.values(row).some((value) =>
          String(value).toLowerCase().includes(word.toLowerCase().trim())
        )
      );

    // Apply modal filters
    const modalFilterMatch = Object.keys(filters).every((key) => {
      if (!filters[key]) return true;

      const rowValue = String(row[key] || "").toLowerCase();
      const filterValue = String(filters[key]).toLowerCase();
      return rowValue.includes(filterValue);
    });

    // Apply DataGrid filters
    const gridFilterMatch = gridFilterModel.items.every((filterItem) => {
      if (!filterItem.value) return true;

      const cellValue = row[filterItem.field];
      const filterValue = filterItem.value;

      switch (filterItem.operator) {
        case "contains":
          return String(cellValue || "")
            .toLowerCase()
            .includes(String(filterValue).toLowerCase());
        case "equals":
          return String(cellValue || "") === String(filterValue);
        case "startsWith":
          return String(cellValue || "")
            .toLowerCase()
            .startsWith(String(filterValue).toLowerCase());
        case "endsWith":
          return String(cellValue || "")
            .toLowerCase()
            .endsWith(String(filterValue).toLowerCase());
        default:
          return true;
      }
    });

    return searchMatch && modalFilterMatch && gridFilterMatch;
  });

  const handleFilterChange = (field, value) => {
    setFilters((prevFilters) => ({
      ...prevFilters,
      [field]: value,
    }));
  };

  // Define the column headers mapping
  const columnHeaders = {
    status: "Status",
    fullname_en: "Full Name",
    suffix: "Suffix",
    balance_usd: "Balance (USD)",
    balance: "Initial Balance",
    client_notes: "Client Notes",
    payment_date: "Payment Date",
    due: "Due",
    expiration_date: "Expiration Date",
    collector: "Collector",
    label: "Label",
    note_details: "Latest Note",
  };

  // Format date fields properly for export — e.g. "21/02/2025 10:25:52 AM"
  const formatDateForExport = (dateValue) => {
    if (!dateValue) return "";
    const date = new Date(dateValue);

    // Format as DD/MM/YYYY HH:MM:SS AM/PM
    const formattedDate = date.toLocaleString("en-GB", {
      day: "2-digit",
      month: "2-digit",
      year: "numeric",
      hour: "2-digit",
      minute: "2-digit",
      second: "2-digit",
      hour12: true,
    });

    // Ensure consistent spacing before AM/PM
    return formattedDate.replace(" am", " AM").replace(" pm", " PM");
  };

  // IMPROVED: Transform rows respecting column visibility
  const transformRowsForExport = (rows) => {
    return rows.map((row) => {
      const transformedRow = {};

      Object.keys(columnHeaders).forEach((field) => {
        // Check if column is visible (if not in columnVisibilityModel or explicitly true)
        const isVisible = columnVisibilityModel[field] !== false;

        if (isVisible) {
          const headerName = columnHeaders[field];

          // Handle special fields with computed values
          if (
            field === "payment_date" ||
            field === "expiration_date" ||
            field === "creation_date"
          ) {
            transformedRow[headerName] = formatDateForExport(row[field]);
          } else {
            transformedRow[headerName] = row[field] || "";
          }
        }
      });

      return transformedRow;
    });
  };

  // IMPROVED: Export function that uses the already-filtered rows
  const handleExportToExcel = () => {
    console.log("Exporting data...");
    console.log("Total data rows:", data.length);
    console.log("Filtered rows:", filteredRows.length);
    console.log("Active filters:", {
      search: searchQuery,
      modalFilters: filters,
      gridFilters: gridFilterModel.items,
    });
    console.log("Column visibility:", columnVisibilityModel);

    // Always use filteredRows which has ALL filters applied
    const transformedRows = transformRowsForExport(filteredRows);

    console.log("Rows to export:", transformedRows.length);

    const worksheet = XLSX.utils.json_to_sheet(transformedRows);
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, "MC");
    XLSX.writeFile(workbook, "MC.xlsx");
  };
  const [isPressed, setIsPressed] = useState(false);

  const handleExportClick = () => {
    setIsPressed(true);
    handleExportToExcel();
    setTimeout(() => {
      setIsPressed(false);
    }, 200);
  };

  const CustomToolbar = () => (
    <GridToolbarContainer>
      <GridToolbarColumnsButton />
      <Button
        onClick={() => setShowFilterModal(true)}
        variant="outline-primary"
        style={{
          border: "none",
        }}
      >
        <img
          src={FilterSVG}
          alt="Filter Icon"
          style={{
            color: "white",
            width: "18px",
            marginRight: "8px",
            filter: "invert(0)", // keep black icon
          }}
        />
        Filter
      </Button>
      {/*<GridToolbarFilterButton />*/}
      <GridToolbarExport />
      <Button
        onClick={handleExportClick}
        variant="outline-success"
        style={{
          display: "flex",
          alignItems: "center",
          padding: "5px 10px",
          fontSize: "14px",
          border: "none",
          backgroundColor: isPressed ? "white" : "transparent",
          color: isPressed ? "black" : "#007bff",
          cursor: "pointer",
        }}
      >
        <img
          src={ExcelSVG}
          alt="Excel Icon"
          style={{
            width: "20px",
            marginRight: "8px",
            filter: isPressed ? "invert(0)" : "invert(1)",
          }}
        />
        Excel
      </Button>
    </GridToolbarContainer>
  );

  const handleDeselectCheckboxes = () => {
    setCheckedRows([]);
  };
  const CustomFooter = ({ selectedCount }) => {
    return (
      <GridFooterContainer
        style={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
        }}
      >
        <Typography style={{ marginLeft: "16px", color: "white" }}>
          {`Selected rows: ${selectedCount}`}
        </Typography>
        <GridPagination />
      </GridFooterContainer>
    );
  };

  return (
    <div className="InternetTable">
      <div className="actions">
        <CustomizedActions
          subscriptions={checkedRows}
          deselect={() => setCheckedRows([])}
          fetch={fetchData}
        />
        <style>{`
        .MuiDataGrid-panelWrapper {
          background: #122632 !important;
        }
      `}</style>
        <input
          type="text"
          placeholder="Search..."
          value={searchInput}
          onChange={handleSearchChange}
          className="search-client"
        />
      </div>
      {!loading && data.length > 0 && (
        <div style={{ height: 570, width: "100%" }}>
          <DataGrid
            rows={filteredRows}
            columns={columns}
            getRowId={getRowId}
            filterModel={gridFilterModel}
            onFilterModelChange={(newModel) => setGridFilterModel(newModel)}
            columnVisibilityModel={columnVisibilityModel}
            onColumnVisibilityModelChange={(newModel) =>
              setColumnVisibilityModel(newModel)
            }
            components={{
              Footer: () => <CustomFooter selectedCount={checkedRows.length} />,
              Toolbar: CustomToolbar,
            }}
            rowsPerPageOptions={[10, 100, 1000]}
            pageSize={pageSize}
            pagination
            onPageSizeChange={(newPageSize) => {
              setPageSize(newPageSize);
              setCheckedRows([]);
            }}
            page={currentPage}
            onPageChange={(newPage) => setCurrentPage(newPage)}
            disableSelectionOnClick
          />
        </div>
      )}

      {/* Postpone Confirmation Modal */}
      <Modal show={showPostponeModal} onHide={ClosePostponeModal}>
        <Modal.Header closeButton>
          <Modal.Title>Confirm Postpone</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          Are you sure you want to postpone this subscription?
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={ClosePostponeModal}>
            No
          </Button>
          <Button variant="primary" onClick={handlePostponeConfirm}>
            Yes
          </Button>
        </Modal.Footer>
      </Modal>

      <Modal show={show} onHide={CloseCollect} className="modal-lg">
        <div className="forma">
          <Modal.Header closeButton>
            <Modal.Title>{Fullname} Notes</Modal.Title>
          </Modal.Header>
          <Notes sub_id={Client} />
        </div>
      </Modal>
      <Modal
        show={showNotification}
        onHide={CloseNotification}
        className="modal-lg"
      >
        <div className="forma">
          <Modal.Header closeButton>
            <Modal.Title>Notification for {Fullname}</Modal.Title>
          </Modal.Header>
          <Notification sub_id={Client} />
        </div>
      </Modal>
      <Modal show={showReceipt} onHide={CloseReceipt} className="modal-lg">
        <div className="forma">
          <Modal.Header closeButton>
            <Modal.Title>{Fullname} Receipts</Modal.Title>
          </Modal.Header>
          <ReceiptTable client_id={Cl} />
        </div>
      </Modal>
      <Modal show={showStatement} onHide={CloseStatement}>
        <Modal.Header closeButton>
          <Modal.Title>Statement of Account</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Statement client_id={Cl} />
        </Modal.Body>
        <Modal.Footer>
          <Button
            variant="secondary"
            onClick={CloseStatement}
            className="modal-xl"
          >
            Close
          </Button>
        </Modal.Footer>
      </Modal>
      <Modal show={showCollectedModal} onHide={CloseCollectedModal}>
        <Modal.Header closeButton>
          <Modal.Title>To be Collected</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          Are you sure you want to collect this subscription?
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={CloseCollectedModal}>
            No
          </Button>
          <Button variant="primary" onClick={handleCollectedConfirm}>
            Yes
          </Button>
        </Modal.Footer>
      </Modal>
      <Modal show={showFilterModal} onHide={() => setShowFilterModal(false)}>
        <Modal.Header closeButton>
          <Modal.Title>Filters</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          {Object.keys(columnHeaders).map((field) => (
            <div key={field} className="filter">
              <label>{columnHeaders[field]}</label>
              <input
                type="text"
                placeholder={`Filter by ${columnHeaders[field]}`}
                value={filters[field] || ""}
                onChange={(e) => handleFilterChange(field, e.target.value)}
                className="filter-input"
              />
            </div>
          ))}
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={() => setShowFilterModal(false)}>
            Close
          </Button>
        </Modal.Footer>
      </Modal>
    </div>
  );
}

export default ICON;
